module.exports = __webpack_public_path__ + "static/media/arrow_up.27611edb.svg";